import React from 'react';

import { useTranslation } from '../../../../hooks/useTranslation/useTranslation';
import styles from './GameRoadmap.module.css';
import { GameRoadmapProps } from './GameRoadmap.types';

export const GameRoadmap: React.FC<GameRoadmapProps> = ({ roadmap }) => {
  const { t } = useTranslation();

  const getStatusLabel = (status: 'completed' | 'in-progress' | 'planned') => {
    switch (status) {
      case 'completed':
        return t.games.roadmap.statusCompleted;
      case 'in-progress':
        return t.games.roadmap.statusInProgress;
      default:
        return t.games.roadmap.statusPlanned;
    }
  };

  const getCardStatusClass = (status: 'completed' | 'in-progress' | 'planned') => {
    switch (status) {
      case 'completed':
        return styles.cardCompleted;
      case 'in-progress':
        return styles.cardInProgress;
      default:
        return styles.cardPlanned;
    }
  };

  const getBadgeStatusClass = (status: 'completed' | 'in-progress' | 'planned') => {
    switch (status) {
      case 'completed':
        return styles.statusCompleted;
      case 'in-progress':
        return styles.statusInProgress;
      default:
        return styles.statusPlanned;
    }
  };

  return (
    <section className={styles.roadmapContainer} aria-labelledby="roadmap-heading">
      <div className={styles.headerArea}>
        <h2 id="roadmap-heading" className={styles.title}>
          {t.games.roadmap.title}
        </h2>
        <p className={styles.subtitle}>{t.games.roadmap.subtitle}</p>
      </div>

      <div className={styles.timelineList}>
        {roadmap.map((item) => (
          <article
            key={item.phase}
            className={`${styles.timelineCard} ${getCardStatusClass(item.status)}`}
          >
            <div className={styles.cardHeader}>
              <div className={styles.phaseTitleGroup}>
                <span className={styles.phaseTag}>{item.phase}</span>
                <h3 className={styles.phaseName}>{item.title}</h3>
              </div>

              <div className={styles.statusRow}>
                <span className={styles.dateBadge}>{item.date}</span>
                <span className={`${styles.statusBadge} ${getBadgeStatusClass(item.status)}`}>
                  {getStatusLabel(item.status)}
                </span>
              </div>
            </div>

            <ul className={styles.itemsList}>
              {item.items.map((bullet, idx) => (
                <li key={idx} className={styles.itemBullet}>
                  {bullet}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
};
